import { SiCsharp, SiJavascript, SiHtml5, SiCss3 } from 'react-icons/si'
import { SiDotnet, SiReact, SiGraphql } from 'react-icons/si'
import { SiMicrosoftsqlserver, SiPostgresql, SiRedis, SiApachekafka, SiRabbitmq } from 'react-icons/si'
import { SiDocker, SiRedhatopenshift, SiPrometheus, SiGrafana, SiGit } from 'react-icons/si'
import { FaRobot } from 'react-icons/fa'

const skills = [
  { id: 1, icon: <SiCsharp />, name: 'C#' },
  { id: 2, icon: <SiDotnet />, name: '.NET Core' },
  { id: 3, icon: <SiReact />, name: 'React' },
  { id: 4, icon: <SiJavascript />, name: 'JavaScript' },
  { id: 5, icon: <SiHtml5 />, name: 'HTML5' },
  { id: 6, icon: <SiCss3 />, name: 'CSS3' },
  { id: 7, icon: <SiGraphql />, name: 'GraphQL' },
  { id: 8, icon: <SiMicrosoftsqlserver />, name: 'SQL Server' },
  { id: 9, icon: <SiPostgresql />, name: 'PostgreSQL' },
  { id: 10, icon: <SiRedis />, name: 'Redis' },
  { id: 11, icon: <SiApachekafka />, name: 'Kafka' },
  { id: 12, icon: <SiRabbitmq />, name: 'RabbitMQ' },
  { id: 13, icon: <SiDocker />, name: 'Docker' },
  { id: 14, icon: <SiRedhatopenshift />, name: 'OpenShift' },
  { id: 15, icon: <SiPrometheus />, name: 'Prometheus' },
  { id: 16, icon: <SiGrafana />, name: 'Grafana' },
  { id: 17, icon: <SiGit />, name: 'Git' },
  { id: 18, icon: <FaRobot />, name: 'Claude Code' },
]

export default skills
